import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=57e96af3&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=ts"
export * from "./Homepage.vue?vue&type=script&lang=ts"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=57e96af3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e96af3",
  null
  
)

export default component.exports